export default "__VITE_ASSET__Cg$JPcId__"